import { format } from "date-fns";
import { postsList } from "../../../datasets/blog/postsList";
import background from "../../../assets/demyst_meta_image.png";

export const FirstPost = ({ post }) => {
  return (
    <section className="first_post-main">
      <div key={post.title} className="first_post-post">
        <a href={new URL(post.url).pathname.replace("/<slug>", "")}>
          <section className="first_post-textarea">
            <h2 className="first_post-title">{post.title}</h2>
            <p className="first_post-description">{post.summary}</p>
            <p className="first_post-date">{format(new Date(post.published), "LLLL dd, yyyy")}</p>
            <p className="first_post-more">{postsList.more}</p>
          </section>
          <div
            className="first_post-image"
            style={{
              backgroundImage: `url(${post?.featured_image ? post.featured_image : background})`,
            }}
          />
        </a>
      </div>
    </section>
  );
};
